import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const AccountTitle = styled.div<React.CSSProperties>`
  color: ${Colors['light']};
  font-family: ${Fonts['bold']};
  font-size: ${40 * Screen.widthRatio}px;
  line-height: ${38 * Screen.widthRatio}px;
  width: ${1000 * Screen.widthRatio}px;
`;

export default AccountTitle;
